import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import HomePage from '../components/home-page/home-page'
import dataLoad from '../actions/data-load';
import { appLogout, appReload } from '../actions';

function mapStateToProps(state) {
  return {
    user: state.user,
    customerCount: state.customerCount,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    appLogout,
    appReload,
    dataLoad,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);